export const environment = {
  env: 'prod',
  production: true,
  apiUrl: `${window.location.origin}/api/data/rest`,
  reCaptchaSiteKeyV3: '6Ld-i6wUAAAAAL4IqHT543mlBC-3cQeGRv43L2I3',
  staticServer: 'https://static-resource.nv.at/media/prod',
  serviceWorker: true
};
